// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-scheduler {
    background: white;
    border-radius: 15px;
    padding: 2rem;
    /* margin-top: 2rem; */
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    border: 5px solid #1a73e8; /* Added 15px solid border with a professional blue color */
}

.calendar-header {
    text-align: center;
    margin-bottom: 2rem;
}

.calendar-header h2 {
    color: #2c3e50;
    font-size: 2.2rem;
    margin-bottom: 0.5rem;
}

.calendar-header p {
    color: #6c757d;
    font-size: 1rem;
}

.calendar-iframe {
    border: 5px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
  }`, "",{"version":3,"sources":["webpack://./src/components/GoogleCalendar.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;IAC1C,yBAAyB,EAAE,2DAA2D;AAC1F;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB","sourcesContent":[".calendar-scheduler {\n    background: white;\n    border-radius: 15px;\n    padding: 2rem;\n    /* margin-top: 2rem; */\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n    border: 5px solid #1a73e8; /* Added 15px solid border with a professional blue color */\n}\n\n.calendar-header {\n    text-align: center;\n    margin-bottom: 2rem;\n}\n\n.calendar-header h2 {\n    color: #2c3e50;\n    font-size: 2.2rem;\n    margin-bottom: 0.5rem;\n}\n\n.calendar-header p {\n    color: #6c757d;\n    font-size: 1rem;\n}\n\n.calendar-iframe {\n    border: 5px solid #ddd;\n    border-radius: 8px;\n    overflow: hidden;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
